import { forwardRef, type InputHTMLAttributes } from 'react';

interface InputProps extends InputHTMLAttributes<HTMLInputElement> {
  /** ラベル */
  label?: string;
  /** エラーメッセージ */
  error?: string;
}

/**
 * @graph-stack mall
 * @graph-domain Operations
 * @graph-business テキスト入力。エメラルドフォーカスリングとglass背景を適用した入力フィールド
 * @graph-connects none
 */
export const Input = forwardRef<HTMLInputElement, InputProps>(
  ({ label, error, className = '', id, ...props }, ref) => {
    const inputId = id ?? label?.toLowerCase().replace(/\s+/g, '-');

    return (
      <div className="space-y-1.5">
        {label && (
          <label
            htmlFor={inputId}
            className="block text-sm font-medium text-[var(--color-text-secondary)]"
          >
            {label}
          </label>
        )}
        <input
          ref={ref}
          id={inputId}
          className={`
            w-full px-4 py-2.5 rounded-lg
            bg-[var(--color-bg-elevated)] text-[var(--color-text-primary)]
            border border-[var(--color-border)]
            placeholder-[var(--color-text-disabled)]
            transition-all duration-[var(--transition-fast)]
            focus:outline-none focus:ring-2 focus:ring-[var(--color-accent-primary)] focus:border-[var(--color-border-focus)]
            hover:border-[var(--color-border-hover)]
            disabled:opacity-50 disabled:cursor-not-allowed
            ${error ? 'border-[var(--color-error)] focus:ring-[var(--color-error)]' : ''}
            ${className}
          `}
          {...props}
        />
        {error && <p className="text-sm text-[var(--color-error)]">{error}</p>}
      </div>
    );
  },
);

Input.displayName = 'Input';
